// レスポンシブ用ブレイクポイントを一元管理
// 必要に応じて後から編集可能

export const breakpoints = {
  mobile: 768, // 例: 768px未満をモバイル
  desktop: 768, // 例: 768px以上をデスクトップ
};

export const media = {
  mobile: `@media (max-width: ${breakpoints.mobile - 1}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`
};
